import React from "react";
import { deleteUser, signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { deleteAccount } from "../utils/api";
import "./Dashboard.css";

function Dashboard() {
  const navigate = useNavigate();
  const user = auth.currentUser;
  const email = user.email;

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      alert("로그아웃 성공");
      navigate("/", { replace: true });
    } catch (error) {
      alert("로그아웃 실패", "관리자에게 문의하세요!");
      console.error("Failed SignOut : ", error.message);
    }
  };

  const handleDeleteAccount = async () => {
    const confirmDelete = window.confirm(
      "정말로 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다."
    );
    if (!confirmDelete) {
      return; // 취소하면 그냥 함수 종료
    }

    try {
      const uid = user.uid;
      if (user) {
        await deleteUser(user);
        await deleteAccount(email, uid); // 서버에도 삭제 요청하려면 추가
        alert("계정 삭제 성공");
        navigate("/", { replace: true });
      }
    } catch (error) {
      alert("계정 삭제 실패: 관리자에게 문의하세요!");
      console.error("Failed Delete Account: ", error.message);
    }
  };

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Kiwe Delete Account Web</h1>
      <h2 className="dashboard-subtitle">
        {email ? `${email} 님, 안녕하세요.` : "로그인 정보 없음"}
      </h2>
      <button className="dashboard-button logout" onClick={handleSignOut}>
        로그아웃
      </button>
      <button className="dashboard-button delete" onClick={handleDeleteAccount}>
        계정 삭제
      </button>
    </div>
  );
}

export default Dashboard;
